<template>
  <div class="ready-data business-open-content">
    <div style="height: 15px"></div>
    <div class="ready-data-content">
      <div style="clear: both">
        <div
          v-if="false"
          class="phy new-style"
          style="margin-right: 25px; margin-left: 65px"
          :class="{ 'item-ejjc': selectedShopType === 'ptch' }"
          @click="shopClickHandler('ptch')"
        >
          <span class="item-select" v-show="selectedShopType === 'ptch'">
            <i style="margin-left: 2px" class="icon-ccui-check-long"></i>
          </span>
          <span class="topTriangle"></span>
          <div class="titleStyle titleFonts">平台撮合店</div>
          <span class="buttomTriangle"></span>
          <div class="information">
            <p v-for="(item, index) in infor2" :key="index" v-html="item"></p>
            <!-- <p>
              9、法人店铺授权委托书&nbsp;<span
                style="font-size: 13px; color: #9b9b9b"
                >请下载</span
              ><a
                target="_blank"
                :href="downFileUrl1"
                download="授权委托书模板.doc"
                style="color: #0089ef; font-size: 13px"
                >授权委托书模板</a
              >
            </p> -->
          </div>
        </div>
        <div
          class="phy new-style"
          style="margin-left: 25px"
          :class="{ 'item-ejjc': selectedShopType === 'ptsf' }"
          @click="shopClickHandler('ptsf')"
          v-if="false"
        >
          <span class="item-select" v-show="selectedShopType === 'ptsf'">
            <i style="margin-left: 2px" class="icon-ccui-check-long"></i>
          </span>
          <span class="topTriangle"></span>
          <div class="titleStyle titleFonts">平台三方店</div>
          <span class="buttomTriangle"></span>
          <div class="information">
            <p v-for="(item, index) in infor3" :key="index">{{ item }}</p>
            <!-- <p>
              9、法人店铺授权委托书&nbsp;<span
                style="font-size: 13px; color: #9b9b9b"
                >请下载</span
              ><a
                target="_blank"
                :href="downFileUrl1"
                download="授权委托书模板.doc"
                style="color: #0089ef; font-size: 13px"
                >授权委托书模板</a
              >
            </p> -->
          </div>
        </div>
      <!-- </div> -->
      <!-- <div style="clear: both"> -->
        <div
          class="phy"
          :class="{ 'item-ejjc': selectedShopType === 'ejjc' }"
          style="margin-right: 25px; margin-left: 25px; margin-bottom: 40px"
          @click="shopClickHandler('ejjc')"
        >
          <span class="item-select" v-show="selectedShopType === 'ejjc'">
            <i style="margin-left: 2px" class="icon-ccui-check-long"></i>
          </span>
          <span class="topTriangle"></span>
          <div class="titleStyle titleFonts">二级集采店</div>
          <span class="buttomTriangle"></span>
          <div class="information">
            <p v-for="(item, index) in infor1" :key="index" v-html="item">
              {{ item }}
            </p>
            <p style="font-weight: bold">
              7、二级集采店上线品类：型材、电线电缆、外加剂（减水剂、速凝剂）、道路护栏、锚具
              、给排水管、支座、伸缩缝、土木合成、止排水、防水材料、护舷、阻尼器，上线商品主要针对中交集团二级集采目录产品
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="goToShop">
      <div class="goToShopDetails">
        <el-checkbox v-model="checked" />我已阅读并接受<span
          class="shopagreementcss"
          @click="shopagreementHand"
          >《商家入驻协议》</span
        >
      </div>
    </div>
    <div
      v-if="checked"
      class="data-bottom-btn"
      style="
        margin-bottom: 20px;
        font-family: PingFangSC-Semibold, PingFangSC;
        font-weight: 600;
      "
      @click="nextStepClick"
    >
      下一步
    </div>
    <div
      v-else
      class="data-bottom-btn1"
      style="
        margin-bottom: 20px;
        font-family: PingFangSC-Semibold, PingFangSC;
        font-weight: 600;
      "
    >
      下一步
    </div>
    <el-dialog
      title="商家入驻协议"
      :visible.sync="shopagreement"
      width="700px"
      show-divider
      show-shadow
      :before-close="handleClose"
      class="dialog-center"
      custom-class="el-dialog--customize"
    >
      <div v-if="agreementsUrl" style="height: 530px">
        <iframe
          :src="agreementsUrl"
          frameborder="0"
          style="width: 100%; height: 100%; overflow: auto"
        ></iframe>
      </div>
      <!-- <div
        class="agreementModalCss"
        v-else
        v-html="shopagreements.shopagreements"
      /> -->

      <span slot="footer">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="shopagreement = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ScrollPane from "@/views/layout/components/TagsView/ScrollPane";
import shopagreements from "./shop-agreement";
const typeMap = {
  ptch: 0,
  ptsf: 1,
}
export default {
  name: "readyDataIndex",
  components: { ScrollPane },
  data() {
    return {
      agreementsUrl:
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100112/default/202412/39686322c607476f9bf19adf3c5e765b.pdf" +
        "#toolbar=0&view=FitH",
      selectedShopType: "",
      downFileUrl1: this.$addUrlPerFix(process.env.VUE_APP_FILE_URL_FILE),
      shopagreement: false,
      shopagreements: shopagreements,
      infor1: [
        "1、企业营业执照副本复印件（三证合一，需完成有效年检且所售商品属于经营范围内）",
        "2、一般纳税人证",
        "3、银行开户许可证复印件",
        "4、法定代表人身份证正反面复印件",
        "5、店铺负责人身份证正反面复印件",
        "6、由国家商标总局颁发的商标注册证或商标注册申请受理通知书复印件（若办理过变更、转让、 续展，请一并提供商标总局颁发的变更、转让、续展证明或受理通知书）",
      ],
      infor2: [
        "合作模式：",
        "供应商与中交集团各单位有历史合作背景，且当前有正在执行中的合同，可申请开设平台撮合店。",
        "开店须知：",
        "1、店铺经营范围为工业品或办公类产品，不包含中交集团一级和二级集采类目产品；",
        "2、商家需满足中交集团供应商准入条件要求，注册开店前需在中交供应链系统完成注册并与中交电商公司建立合作意向（详见交建云商平台供应商准入条件及资质文件填报要求）；",
        "3、注册店铺时需提供中交集团内部采购单位推荐函、推荐单位采购寻源中标通知书和相应的采购合同；",
        "4、需与中交电商公司签订“平台技术服务协议”，协议模板见申请流程；",
        "5、商家按平台发布的运营规则自主开展店铺经营；",
        "6、商家可与平台采购客户自主协商签订相关采购合同，对账开票、结算付款由商家与采购客户自行协商，中交电商公司只提供平台技术服务，不承担商家和采购客户双方的交易履约责任；",
        "7、中交电商公司按协议约定，收取一定比例的平台技术服务费。"
      ],
      infor3: [
        "合作模式：",
        "面向更广泛的社会资源，满足中交集团、中交电商公司相关准入条件和管理要求，均可申请开设平台三方店。",
        "开店须知：",
        "1、店铺经营范围为工业品和办公类产品，不包含中交集团一级和二级集采类目产品；",
        "2、商家需满足中交集团供应商准入条件要求，注册开店前需在中交供应链系统完成注册并与中交电商公司建立合作意向（详见交建云商平台供应商准入条件及资质文件填报要求）；",
        "3、需与中交电商公司签订“平台技术服务协议”，协议模板见申请流程；",
        "4、商家按平台发布的运营规则自主开展店铺经营；",
        "5、商家可与平台采购客户自主协商签订相关采购合同，对账开票、结算付款由商家与采购客户自行协商，中交电商公司只提供平台技术服务，不承担商家和采购客户双方的交易履约责任；",
        "6、中交电商公司按协议约定，收取一定比例的平台技术服务费。"
      ],
      checked: false,
    };
  },
  mounted() {
    this.$store.commit("RELOAD_SET", false);
  },
  methods: {
    shopClickHandler(shopType) {
      console.log(shopType);
      if (this.selectedShopType === shopType) {
        this.selectedShopType = "";
      } else {
        this.selectedShopType = shopType;
      }
      // if (this.selectedShopType === "ejjc") {
      //   this.agreementsUrl = "";
      // } else {
      //   this.agreementsUrl = null;
      // }
    },
    down() {
      console.log("fdsfds");
    },
    nextStepClick() {
      if (!this.selectedShopType) {
        return this.$message({
          showClose: true,
          type: "error",
          message: "请选择店铺类型",
          ccuiCustom: true,
        });
      }
      const { supName = "" } = this.$route.query;
      if (this.selectedShopType === "ejjc") {
        console.log("勾选了二级集采");
        return this.$router.push(
          `/lessor-open-shop?orderPurchaseType=10&supName=${supName}`
        );
      }
      this.$store.commit("DEL_CACHED_VIEW", { name: "applyShopInfo" });
      this.$store.commit("DEL_CACHED_VIEW", { name: "contractBusinessInfo" });
      this.$store.commit("DEL_CACHED_VIEW", { name: "inputBusinessInfo" });
      this.$store.dispatch("businessOpenShopSetStep", 2);
      sessionStorage.setItem("orderPurchaseType", typeMap[this.selectedShopType]);
      this.$router.replace(`/business-open-shop/register`);
    },
    shopagreementHand() {
      this.shopagreement = true;
    },
    handleClose(done) {
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.item-ejjc {
  position: relative;
  border: 2px solid #ff142f !important;
  .item-select {
    position: absolute;
    z-index: 999;
    width: 30px;
    height: 20px;
    line-height: 24px;
    right: 0;
    bottom: 0;
    background-color: red;
    border-radius: 12px 0 0 0;
    text-align: center;
    .icon-ccui-check-long::before {
      color: #fff;
    }
  }
}
.ready-data {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  // min-height: calc(100vh - 285px) !important;
  height: auto !important;

  .goToShop {
    width: 1180px;
    height: 18px;
    margin-bottom: 20px;
    font-family: PingFang-SC-Medium;
    font-size: 13px;
    color: #9b9b9b;
    line-height: 18px;
    .goToShopDetails {
      width: 290px;
      height: 100%;
      margin: 0 auto;
      text-align: center;
    }
    .shopagreementcss {
      color: #f50b25;
      cursor: pointer;
    }
  }
}
.ready-data-content {
  width: 100%;
  min-height: 245px;
  .phy {
    // float: left;
    margin-top: 30px;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 8px;
    border: 2px solid #fff;
    cursor: pointer;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.23);
    float: left;
    .information {
      //width: 460px;
      height: 357px;
      margin-top: 20px;
      margin-left: 20px;
      overflow-y: auto;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #4a4a4a;
      padding: 0 20px;
      p {
        margin: 16px 0px;
      }
    }
    &.new-style {
      .information {
        p:nth-of-type(2) {
          margin-top: 0;
          margin-bottom: 20px;
        }
        p:not(:nth-of-type(2)) {
          margin: 8px 0px;
        }
      }
    }
    .titleStyle {
      width: 160px;
      height: 40px;
      background: #ff262b;
      border-radius: 0 18.5px 18.5px 0;
      border-radius: 0px 18.5px 18.5px 0px;
      margin-left: -9px;
    }
    .titleFonts {
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
    .topTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      margin-top: 11px;
      border-bottom: 9px solid brown;
      border-left: 9px solid transparent;
    }
    .buttomTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      border-top: 9px solid brown;
      border-left: 9px solid transparent;
    }
  }
  .phy1 {
    //margin-top: 30px;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.23);
    float: left;
    .information {
      //width: 460px;
      height: 357px;
      margin-top: 20px;
      margin-left: 20px;
      overflow-y: auto;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #4a4a4a;
      padding: 0 20px;
      p {
        margin: 16px 0px;
      }
    }
    .titleStyle {
      width: 160px;
      height: 40px;
      background: #ff262b;
      border-radius: 0 18.5px 18.5px 0;
      border-radius: 0px 18.5px 18.5px 0px;
      margin-left: -9px;
    }
    .titleFonts {
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
    .topTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      margin-top: 11px;
      border-bottom: 9px solid brown;
      border-left: 9px solid transparent;
    }
    .buttomTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      border-top: 9px solid brown;
      border-left: 9px solid transparent;
    }
  }
  > span {
    font-size: 36px;
    font-weight: 400;
    color: #999999;
  }
}
.business-open-content {
  margin-top: 20px;
}

.agreementModalCss {
  color: #666666;
  font-size: 13px;
  padding: 0 50px;
  height: 530px;
  overflow-y: auto;
  /deep/ .title {
    display: block;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 10px;
    font-weight: 600;
  }
  /deep/ > div:nth-of-type(1) {
    margin-bottom: 20px;
  }
  /deep/ > div:nth-of-type(2) {
    div {
      margin-top: 10px;
      margin-bottom: 5px;
    }
    span {
      display: block;
    }
  }
}
/deep/ .title {
  display: block;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: 微软雅黑;
  color: #212121;
}
/deep/ .remind {
  isplay: block;
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: 微软雅黑;
  color: red;
}
/deep/ .titleInfor {
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: 微软雅黑;
  color: #212121;
}
/deep/ .el-checkbox {
  margin-right: 5px;
}
/deep/ .infrobottom {
  margin-bottom: 20px;
}
/deep/ .el-dialog--customize .el-dialog__body {
  max-height: 130vh !important;
}
</style>
